var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_10008)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0098EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#0098EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9261 17.8602H21.0727C17.0546 17.8602 14.508 22.1945 16.5294 25.6984L30.0165 49.0753C30.8966 50.6017 33.1022 50.6017 33.9823 49.0753L47.4721 25.6984C49.4909 22.2001 46.9441 17.8602 42.9288 17.8602H42.9261ZM30.0055 42.0649L27.0682 36.3802L19.9809 23.7045C19.5134 22.8931 20.0909 21.8535 21.07 21.8535H30.0028V42.0677L30.0055 42.0649ZM44.0124 23.7017L36.9278 36.383L33.9905 42.0649V21.8507H42.9233C43.9024 21.8507 44.4799 22.8904 44.0124 23.7017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_10008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/TON.ad47943339bb6c57ed729c6205190984.svg";
export { ForwardRef as ReactComponent };